import React from "react";

export default function EmptyState({ title = "No records found", description, action }) {
  return (
    <div className={`np-empty-state${action ? " np-empty-state--with-action" : ""}`}>
      <p className="np-empty-state__title">{title}</p>
      {description && <p className="np-empty-state__description">{description}</p>}
      {action && <div className="np-empty-state__action">{action}</div>}
    </div>
  );
}
